/* ==========================================================================
   AIRDOG AUSTRALIA — Homepage scripts
   Vanilla JS, no dependencies. Progressive enhancement; all demos functional.
   ========================================================================== */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Year ---------- */
  var yr = $('#year'); if (yr) yr.textContent = new Date().getFullYear();

  /* ---------- Super-header dismiss ---------- */
  var superClose = $('#superClose');
  if (superClose) superClose.addEventListener('click', function () {
    $('#superbar').classList.add('is-hidden');
  });

  /* ---------- Header scroll state ---------- */
  var header = $('#header');
  function onScroll() {
    if (window.scrollY > 40) header.setAttribute('data-mode', 'solid');
    else header.setAttribute('data-mode', 'transparent');
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---------- Mobile menu ---------- */
  var hamburger = $('#hamburger'), mobileMenu = $('#mobileMenu');
  if (hamburger) hamburger.addEventListener('click', function () {
    var open = mobileMenu.classList.toggle('is-open');
    hamburger.setAttribute('aria-expanded', String(open));
    mobileMenu.setAttribute('aria-hidden', String(!open));
    document.body.classList.toggle('menu-open', open);
  });
  $$('#mobileMenu a').forEach(function (a) {
    a.addEventListener('click', function () {
      mobileMenu.classList.remove('is-open');
      hamburger.setAttribute('aria-expanded', 'false');
      mobileMenu.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('menu-open');
    });
  });

  /* ---------- Scroll reveal ---------- */
  var revealEls = $$('section .container > *, .hero__copy, .section-head');
  // mark major blocks
  $$('.section-head, .pcard, .needtile, .process__step, .demo, .teaser__card, .proof__quote').forEach(function (el) {
    el.classList.add('reveal');
  });
  if ('IntersectionObserver' in window && !reduceMotion) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    $$('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    $$('.reveal').forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---------- Sticky mobile CTA ---------- */
  var sticky = $('#stickyCta'), hero = $('.hero');
  if (sticky && hero && 'IntersectionObserver' in window) {
    var so = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        sticky.classList.toggle('is-visible', !e.isIntersecting);
        sticky.setAttribute('aria-hidden', String(e.isIntersecting));
      });
    }, { threshold: 0 });
    so.observe(hero);
  }

  /* ---------- Cart (demo) ---------- */
  var cartCount = $('#cartCount'), cart = 0;
  $$('.addcart').forEach(function (btn) {
    btn.addEventListener('click', function () {
      cart++;
      cartCount.textContent = String(cart);
      $('.iconbtn--cart').setAttribute('aria-label', 'Cart, ' + cart + ' items');
      var orig = btn.textContent;
      btn.textContent = 'Added ✓';
      btn.disabled = true;
      setTimeout(function () { btn.textContent = orig; btn.disabled = false; }, 1400);
    });
  });

  // /* ==========================================================================
  //    2. AIR QUALITY — live data from the World Air Quality Index (aqicn.org)
  //    Token is embedded client-side (see WAQI_TOKEN). Rotate after launch.
  //    ========================================================================== */
  // var WAQI_TOKEN = (window.AIRDOG_WAQI_TOKEN || '5afe215a4b6c5f89035e570cb0d0a153fca4cb8d');

  // function aqiClass(v){ return v<=50?'#46c07f':v<=100?'#c3b961':v<=150?'#d68a3a':v<=200?'#b23a48':v<=300?'#8f4bd6':'#7a1f2b'; }
  // function aqiWord(v){ return v<=50?'Good':v<=100?'Moderate':v<=150?'Unhealthy for sensitive groups':v<=200?'Unhealthy':v<=300?'Very unhealthy':'Hazardous'; }
  // var AQ_POLL = {pm25:'PM2.5 (fine particles)',pm10:'PM10 (coarse particles)',o3:'Ozone',no2:'Nitrogen dioxide',so2:'Sulphur dioxide',co:'Carbon monoxide'};

  // var aqValue=$('#aqValue'), aqStatus=$('#aqStatus'), aqMetrics=$('#aqMetrics'), aqErr=$('#aqError'), aqAttr=$('#aqAttr');
  // function aqLoading(){ if(aqValue){aqValue.textContent='…'; aqValue.style.color='';} if(aqErr)aqErr.hidden=true; }
  // function aqShowError(msg){ if(aqValue)aqValue.textContent='—'; if(aqErr){aqErr.hidden=false; if(msg)aqErr.textContent=msg;} }

  // function renderAQ(d){
  //   var aqi=d.aqi;
  //   if(aqValue){ aqValue.textContent=aqi; aqValue.style.color=aqiClass(aqi); }
  //   if(aqStatus){ aqStatus.innerHTML='<strong style="color:'+aqiClass(aqi)+'">'+aqiWord(aqi)+
  //     '</strong> outdoors right now — indoor levels are often higher. Here\u2019s how Airdog handles it.'; }
  //   var dom=(d.dominentpol||'').toLowerCase();
  //   var mCat=$('#mCat'), mDom=$('#mDom'), mPm=$('#mPm');
  //   if(mCat)mCat.textContent=aqiWord(aqi);
  //   if(mDom)mDom.textContent=AQ_POLL[dom]||(dom?dom.toUpperCase():'—');
  //   var pm=(d.iaqi&&d.iaqi.pm25)?d.iaqi.pm25.v:null;
  //   if(mPm)mPm.textContent=(pm!=null)?pm:'—';
  //   if(aqMetrics)aqMetrics.hidden=false;
  //   if(aqAttr){
  //     var nm=(d.city&&d.city.name)?d.city.name:'nearest station';
  //     var url=(d.city&&d.city.url)?d.city.url:'https://waqi.info/';
  //     aqAttr.innerHTML='Live: <a href="'+url+'" target="_blank" rel="noopener">'+nm+'</a> · World Air Quality Index';
  //   }
  // }
  // function fetchAQ(path){
  //   if(!WAQI_TOKEN || WAQI_TOKEN.indexOf('YOUR_')===0){ aqShowError('Air-quality data isn\u2019t configured yet.'); return; }
  //   aqLoading();
  //   fetch('https://api.waqi.info/feed/'+path+'/?token='+encodeURIComponent(WAQI_TOKEN))
  //     .then(function(r){ return r.json(); })
  //     .then(function(j){
  //       if(j && j.status==='ok' && j.data && typeof j.data.aqi==='number'){ renderAQ(j.data); }
  //       else { aqShowError('No station found for that spot — try choosing a city.'); }
  //     })
  //     .catch(function(){ aqShowError('We couldn\u2019t reach the air-quality service. Please try again.'); });
  // }
  // var geoBtn=$('#geoBtn');
  // if(geoBtn) geoBtn.addEventListener('click', function(){
  //   if(!navigator.geolocation){ fetchAQ('here'); return; }
  //   aqLoading();
  //   navigator.geolocation.getCurrentPosition(
  //     function(pos){ fetchAQ('geo:'+pos.coords.latitude+';'+pos.coords.longitude); },
  //     function(){ fetchAQ('here'); },
  //     {timeout:8000, maximumAge:600000}
  //   );
  // });
  // var citySel=$('#citySel');
  // if(citySel) citySel.addEventListener('change', function(){ if(citySel.value) fetchAQ('geo:'+citySel.value); });

  // /* Particle-scale hero count-up */
  // var scaleNum = $('.scale__num');
  // if (scaleNum && 'IntersectionObserver' in window && !reduceMotion) {
  //   var done = false;
  //   var co = new IntersectionObserver(function (entries) {
  //     entries.forEach(function (e) {
  //       if (e.isIntersecting && !done) {
  //         done = true;
  //         var target = 0.0146, start = null;
  //         var step = function (ts) {
  //           if (!start) start = ts;
  //           var p = Math.min((ts - start) / 900, 1);
  //           scaleNum.textContent = (target * p).toFixed(4);
  //           if (p < 1) requestAnimationFrame(step); else scaleNum.textContent = '0.0146';
  //         };
  //         requestAnimationFrame(step);
  //       }
  //     });
  //   }, { threshold: 0.5 });
  //   co.observe(scaleNum);
  // }

  // /* ==========================================================================
  //    4. SEE IT WORK — AQI demo + noise comparator
  //    ========================================================================== */
  // var demoFg = $('#demoRingFg'), demoAqi = $('#demoAqi');
  // var CIRC = 2 * Math.PI * 52; // r=52
  // function setDemoAqi(v) {
  //   if (!demoFg) return;
  //   demoAqi.textContent = v;
  //   var frac = Math.min(v / 200, 1);
  //   demoFg.style.strokeDashoffset = (CIRC * (1 - (1 - frac))) ; // more filled when worse
  //   demoFg.style.strokeDashoffset = CIRC * frac;
  //   demoFg.style.stroke = aqiClass(v);
  //   demoAqi.style.color = '#fff';
  // }
  // if (demoFg) { demoFg.style.strokeDasharray = CIRC; setDemoAqi(4); }
  // var smokeBtn = $('#smokeBtn'), resetBtn = $('#resetBtn'), demoTimer;
  // function animateAqi(from, to, dur) {
  //   if (reduceMotion) { setDemoAqi(to); return; }
  //   clearInterval(demoTimer);
  //   var start = performance.now();
  //   demoTimer = setInterval(function () {
  //     var p = Math.min((performance.now() - start) / dur, 1);
  //     var ease = 1 - Math.pow(1 - p, 3);
  //     setDemoAqi(Math.round(from + (to - from) * ease));
  //     if (p >= 1) clearInterval(demoTimer);
  //   }, 30);
  // }
  // if (smokeBtn) smokeBtn.addEventListener('click', function () {
  //   setDemoAqi(168);
  //   setTimeout(function () { animateAqi(168, 4, 2600); }, 500);
  // });
  // if (resetBtn) resetBtn.addEventListener('click', function () { clearInterval(demoTimer); setDemoAqi(4); });

  // // Noise comparator (visual + optional WebAudio tone)
  // var noiseFill = $('#noiseFill'), noiseCap = $('#noiseCap'), audioCtx = null;
  // $$('#noise button').forEach(function (b) {
  //   b.addEventListener('click', function () {
  //     $$('#noise button').forEach(function (x) { x.classList.remove('is-active'); });
  //     b.classList.add('is-active');
  //     var db = +b.getAttribute('data-db');
  //     noiseFill.style.width = ((db - 20) / 50 * 100) + '%';
  //     noiseCap.textContent = b.getAttribute('data-label') + ' — about ' + db + ' dB.' +
  //       (db <= 58 ? ' Airdog runs from just ≤58 dB.' : '');
  //     // gentle audio cue (user-initiated)
  //     try {
  //       audioCtx = audioCtx || new (window.AudioContext || window.webkitAudioContext)();
  //       var o = audioCtx.createOscillator(), g = audioCtx.createGain();
  //       o.frequency.value = 120 + db * 4; o.type = 'sine';
  //       g.gain.value = 0.0001;
  //       o.connect(g); g.connect(audioCtx.destination);
  //       var t = audioCtx.currentTime;
  //       g.gain.exponentialRampToValueAtTime(Math.min(db / 60, 1) * 0.05, t + 0.05);
  //       g.gain.exponentialRampToValueAtTime(0.0001, t + 0.5);
  //       o.start(t); o.stop(t + 0.5);
  //     } catch (e) { /* audio optional */ }
  //   });
  // });

  /* ==========================================================================
     6. ROOM-SIZE CALCULATOR → recommendation
     ========================================================================== */
  // var roomForm = $('#roomForm');
  // var MODELS = [
  //   { id: 'x1d', name: 'X1D', max: 10 },
  //   { id: 'x3d', name: 'X3D', max: 20 },
  //   { id: 'x5d', name: 'X5D', max: 35 },
  //   { id: 'x8d', name: 'X8D', max: 100 }
  // ];
  // function recommend(m2) {
  //   for (var i = 0; i < MODELS.length; i++) if (m2 <= MODELS[i].max) return MODELS[i];
  //   return MODELS[MODELS.length - 1];
  // }
  // function highlight(id) {
  //   $$('.pcard').forEach(function (c) { c.classList.remove('is-recommended'); });
  //   var card = $('.pcard[data-model="' + id + '"]');
  //   if (card) {
  //     card.classList.add('is-recommended');
  //     card.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
  //   }
  // }
  // if (roomForm) roomForm.addEventListener('submit', function (e) {
  //   e.preventDefault();
  //   var sel = +$('#roomType').value || 0;
  //   var typed = +$('#roomSize').value || 0;
  //   var m2 = typed || sel;
  //   var res = $('#roomResult');
  //   if (!m2) { res.hidden = false; res.innerHTML = 'Tell us a room or a size and we\u2019ll match you.'; return; }
  //   var r = recommend(m2);
  //   res.hidden = false;
  //   res.innerHTML = 'For about <strong>' + m2 + ' m\u00B2</strong>, we recommend the <strong>Airdog ' + r.name + '</strong> — sized for your space, with room to spare.';
  //   highlight(r.id);
  // });

  /* ==========================================================================
     7. COST-OF-OWNERSHIP CALCULATOR (illustrative demo maths)
     ========================================================================== */
  var costForm = $('#costForm'), years = $('#years'), units = $('#units'),
      yearsVal = $('#yearsVal'), saveValue = $('#saveValue'),
      airBar = $('.costchart__bar--air span'), hepaBar = $('.costchart__bar--hepa span');
  // Illustrative only — real figures pending [INSERT VERIFIED COST ASSUMPTIONS]
  var DEMO_FILTER_PRICE = 80, DEMO_REPLACEMENTS_PER_YEAR = 2;
  function calcCost() {
    if (!years) return;
    var y = +years.value, u = +units.value || 1;
    yearsVal.textContent = y;
    var hepaFilters = DEMO_FILTER_PRICE * DEMO_REPLACEMENTS_PER_YEAR * y * u;
    var airdogFilters = 0; // washable
    var saving = hepaFilters - airdogFilters;
    saveValue.textContent = '$' + saving.toLocaleString('en-AU');
    // bars relative
    var max = Math.max(hepaFilters, 1);
    if (airBar) airBar.style.width = '8%';
    if (hepaBar) hepaBar.style.width = Math.min(100, (hepaFilters / max) * 100) + '%';
  }
  if (years) { years.addEventListener('input', calcCost); units.addEventListener('input', calcCost); calcCost(); }
  var assumeBtn = $('#assumeBtn'), assumeBox = $('#assumeBox');
  if (assumeBtn) assumeBtn.addEventListener('click', function () {
    var open = assumeBox.hasAttribute('hidden');
    if (open) assumeBox.removeAttribute('hidden'); else assumeBox.setAttribute('hidden', '');
  });

  /* ==========================================================================
     8. SMART APP — tabs
     ========================================================================== */
  $$('.phone__tabs button').forEach(function (tab) {
    tab.addEventListener('click', function () {
      $$('.phone__tabs button').forEach(function (t) { t.setAttribute('aria-selected', 'false'); });
      tab.setAttribute('aria-selected', 'true');
      var name = tab.getAttribute('data-tab');
      $$('.phone__panel').forEach(function (p) {
        p.hidden = p.getAttribute('data-panel') !== name;
      });
    });
  });

  /* ==========================================================================
     10. EMAIL CAPTURE forms (demo)
     ========================================================================== */
  function validEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); }
  var emailForm = $('#emailForm');
  if (emailForm) emailForm.addEventListener('submit', function (e) {
    e.preventDefault();
    var v = $('#email').value.trim(), msg = $('#emailMsg');
    msg.className = 'emailcap__msg';
    if (!validEmail(v)) { msg.textContent = 'That email doesn\u2019t look right. Mind checking it?'; msg.classList.add('is-err'); return; }
    msg.textContent = 'Check your inbox — your 30% code is on its way. Welcome to cleaner air.';
    msg.classList.add('is-ok');
    emailForm.reset();
  });
  var nlForm = $('#newsletterForm');
  if (nlForm) nlForm.addEventListener('submit', function (e) {
    e.preventDefault();
    var v = $('#nlEmail').value.trim(), msg = $('#nlMsg');
    if (!validEmail(v)) { msg.textContent = 'Please enter a valid email.'; return; }
    msg.textContent = 'Subscribed — your 30% code is on its way.';
    nlForm.reset();
  });

})();

/* ============================================================
   MASTER CHROME — accessible dropdown nav + mobile accordion
   Appended to script.js. Vanilla, progressive-enhancement.
   ============================================================ */
(function () {
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---- Desktop mega dropdowns (click + keyboard; hover handled in CSS) ---- */
  var items = $$('.nav__item.has-mega');

  function closeAll(except) {
    items.forEach(function (it) {
      if (it === except) return;
      it.classList.remove('is-open');
      var btn = it.querySelector('.nav__top');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  }

  items.forEach(function (it) {
    var btn = it.querySelector('.nav__top');
    if (!btn) return;

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var open = !it.classList.contains('is-open');
      closeAll(it);
      it.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', String(open));
    });

    /* Esc closes and returns focus to the trigger */
    it.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.key === 'Esc') {
        if (it.classList.contains('is-open')) {
          it.classList.remove('is-open');
          btn.setAttribute('aria-expanded', 'false');
          btn.focus();
        }
      }
    });

    /* close when focus leaves the item entirely (keyboard tab-out) */
    it.addEventListener('focusout', function () {
      setTimeout(function () {
        if (!it.contains(document.activeElement)) {
          it.classList.remove('is-open');
          btn.setAttribute('aria-expanded', 'false');
        }
      }, 0);
    });
  });

  /* click outside any nav item closes all open dropdowns */
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.nav__item.has-mega')) closeAll(null);
  });

  /* ---- Mobile accordion groups ---- */
  $$('.m-acc__btn').forEach(function (btn) {
    var panel = btn.nextElementSibling;
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!open));
      panel.style.maxHeight = open ? '0px' : (panel.scrollHeight + 'px');
    });
  });
})();

/* Footer accordion — collapsible on mobile only (<720px) */
(function(){
  var mq = window.matchMedia('(max-width:719px)');
  var btns = Array.prototype.slice.call(document.querySelectorAll('.footer__acc'));
  function wire(){
    btns.forEach(function(btn){
      var panel = btn.nextElementSibling;
      if(!panel) return;
      if(mq.matches){
        if(!btn.dataset.wired){
          btn.setAttribute('aria-expanded','false');
          btn.addEventListener('click', function(){
            var open = btn.getAttribute('aria-expanded')==='true';
            btn.setAttribute('aria-expanded', String(!open));
            panel.style.maxHeight = open ? '0px' : (panel.scrollHeight+'px');
          });
          btn.dataset.wired='1';
        }
      } else {
        btn.setAttribute('aria-expanded','true');
        panel.style.maxHeight = '';
      }
    });
  }
  wire();
  if(mq.addEventListener) mq.addEventListener('change', wire);
})();

/* Keep --header-bottom in sync so the full-width mega drops right below the header */
(function(){
  var header=document.getElementById('header');
  if(!header) return;
  function setHB(){ document.documentElement.style.setProperty('--header-bottom', Math.round(header.getBoundingClientRect().bottom)+'px'); }
  setHB();
  window.addEventListener('load', setHB);
  setTimeout(setHB, 400);
  window.addEventListener('scroll', setHB, {passive:true});
  window.addEventListener('resize', setHB);
  var nav=document.querySelector('.nav');
  if(nav){ ['mouseover','focusin','click'].forEach(function(ev){ nav.addEventListener(ev, setHB); }); }
  var sc=document.getElementById('superClose'); if(sc) sc.addEventListener('click', function(){ setTimeout(setHB,10); });
})();
/* ==========================================================================
   AIRDOG — Product page scripts. Loads after shared script.js.
   ========================================================================== */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Gallery ---------- */
  var main = $('#galleryMain');
  $$('#galleryThumbs .gallery__thumb').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var src = btn.getAttribute('data-src');
      if (main) main.src = src;
      $$('#galleryThumbs .gallery__thumb').forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
    });
  });

  /* ---------- Quantity stepper ---------- */
  var qty = $('#qty');
  function clamp(v) { return Math.max(1, Math.min(10, v || 1)); }
  var minus = $('#qtyMinus'), plus = $('#qtyPlus');
  if (minus) minus.addEventListener('click', function () { qty.value = clamp(parseInt(qty.value, 10) - 1); });
  if (plus) plus.addEventListener('click', function () { qty.value = clamp(parseInt(qty.value, 10) + 1); });
  if (qty) qty.addEventListener('change', function () { qty.value = clamp(parseInt(qty.value, 10)); });

  /* ---------- Buy now (demo) ---------- */
  var buyNow = $('#buyNow');
  if (buyNow) buyNow.addEventListener('click', function () {
    buyNow.textContent = 'Redirecting to checkout…';
    setTimeout(function () { buyNow.textContent = 'Buy with Shop Pay'; }, 1600);
  });

  /* ---------- FAQ accordion ---------- */
  $$('#faq .faq__q').forEach(function (q) {
    q.addEventListener('click', function () {
      var open = q.getAttribute('aria-expanded') === 'true';
      q.setAttribute('aria-expanded', String(!open));
      var a = q.nextElementSibling;
      if (!open) {
        a.style.maxHeight = reduceMotion ? 'none' : a.scrollHeight + 'px';
      } else {
        a.style.maxHeight = '0px';
      }
    });
  });

  /* ---------- PDP sticky CTA: show after the buy box scrolls out ---------- */
  var sticky = $('#stickyCta'), buybox = $('.buybox');
  if (sticky && buybox && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        sticky.classList.toggle('is-visible', !e.isIntersecting);
        sticky.setAttribute('aria-hidden', String(e.isIntersecting));
      });
    }, { threshold: 0 });
    io.observe(buybox);
  }
})();
